export interface CountryCode {
  iso: string
  name: string
  dialCode: string
  flag: string
}

export const COUNTRY_CODES: CountryCode[] = [
  { iso: 'AF', name: 'Afghanistan', dialCode: '+93', flag: '🇦🇫' },
  { iso: 'AL', name: 'Albania', dialCode: '+355', flag: '🇦🇱' },
  { iso: 'DZ', name: 'Algeria', dialCode: '+213', flag: '🇩🇿' },
  { iso: 'AS', name: 'American Samoa', dialCode: '+1684', flag: '🇦🇸' },
  { iso: 'AD', name: 'Andorra', dialCode: '+376', flag: '🇦🇩' },
  { iso: 'AO', name: 'Angola', dialCode: '+244', flag: '🇦🇴' },
  { iso: 'AI', name: 'Anguilla', dialCode: '+1264', flag: '🇦🇮' },
  { iso: 'AQ', name: 'Antarctica', dialCode: '+672', flag: '🇦🇶' },
  { iso: 'AG', name: 'Antigua and Barbuda', dialCode: '+1268', flag: '🇦🇬' },
  { iso: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { iso: 'AM', name: 'Armenia', dialCode: '+374', flag: '🇦🇲' },
  { iso: 'AW', name: 'Aruba', dialCode: '+297', flag: '🇦🇼' },
  { iso: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { iso: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹' },
  { iso: 'AZ', name: 'Azerbaijan', dialCode: '+994', flag: '🇦🇿' },
  { iso: 'BS', name: 'Bahamas', dialCode: '+1242', flag: '🇧🇸' },
  { iso: 'BH', name: 'Bahrain', dialCode: '+973', flag: '🇧🇭' },
  { iso: 'BD', name: 'Bangladesh', dialCode: '+880', flag: '🇧🇩' },
  { iso: 'BB', name: 'Barbados', dialCode: '+1246', flag: '🇧🇧' },
  { iso: 'BY', name: 'Belarus', dialCode: '+375', flag: '🇧🇾' },
  { iso: 'BE', name: 'Belgium', dialCode: '+32', flag: '🇧🇪' },
  { iso: 'BZ', name: 'Belize', dialCode: '+501', flag: '🇧🇿' },
  { iso: 'BJ', name: 'Benin', dialCode: '+229', flag: '🇧🇯' },
  { iso: 'BM', name: 'Bermuda', dialCode: '+1441', flag: '🇧🇲' },
  { iso: 'BT', name: 'Bhutan', dialCode: '+975', flag: '🇧🇹' },
  { iso: 'BO', name: 'Bolivia', dialCode: '+591', flag: '🇧🇴' },
  { iso: 'BA', name: 'Bosnia and Herzegovina', dialCode: '+387', flag: '🇧🇦' },
  { iso: 'BW', name: 'Botswana', dialCode: '+267', flag: '🇧🇼' },
  { iso: 'BR', name: 'Brazil', dialCode: '+55', flag: '🇧🇷' },
  {
    iso: 'IO',
    name: 'British Indian Ocean Territory',
    dialCode: '+246',
    flag: '🇮🇴',
  },
  { iso: 'VG', name: 'British Virgin Islands', dialCode: '+1284', flag: '🇻🇬' },
  { iso: 'BN', name: 'Brunei', dialCode: '+673', flag: '🇧🇳' },
  { iso: 'BG', name: 'Bulgaria', dialCode: '+359', flag: '🇧🇬' },
  { iso: 'BF', name: 'Burkina Faso', dialCode: '+226', flag: '🇧🇫' },
  { iso: 'BI', name: 'Burundi', dialCode: '+257', flag: '🇧🇮' },
  { iso: 'KH', name: 'Cambodia', dialCode: '+855', flag: '🇰🇭' },
  { iso: 'CM', name: 'Cameroon', dialCode: '+237', flag: '🇨🇲' },
  { iso: 'CA', name: 'Canada', dialCode: '+1', flag: '🇨🇦' },
  { iso: 'CV', name: 'Cape Verde', dialCode: '+238', flag: '🇨🇻' },
  { iso: 'KY', name: 'Cayman Islands', dialCode: '+1345', flag: '🇰🇾' },
  { iso: 'CF', name: 'Central African Republic', dialCode: '+236', flag: '🇨🇫' },
  { iso: 'TD', name: 'Chad', dialCode: '+235', flag: '🇹🇩' },
  { iso: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { iso: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳' },
  { iso: 'CX', name: 'Christmas Island', dialCode: '+61', flag: '🇨🇽' },
  { iso: 'CC', name: 'Cocos Islands', dialCode: '+61', flag: '🇨🇨' },
  { iso: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴' },
  { iso: 'KM', name: 'Comoros', dialCode: '+269', flag: '🇰🇲' },
  { iso: 'CK', name: 'Cook Islands', dialCode: '+682', flag: '🇨🇰' },
  { iso: 'CR', name: 'Costa Rica', dialCode: '+506', flag: '🇨🇷' },
  { iso: 'HR', name: 'Croatia', dialCode: '+385', flag: '🇭🇷' },
  { iso: 'CU', name: 'Cuba', dialCode: '+53', flag: '🇨🇺' },
  { iso: 'CW', name: 'Curacao', dialCode: '+599', flag: '🇨🇼' },
  { iso: 'CY', name: 'Cyprus', dialCode: '+357', flag: '🇨🇾' },
  { iso: 'CZ', name: 'Czech Republic', dialCode: '+420', flag: '🇨🇿' },
  {
    iso: 'CD',
    name: 'Democratic Republic of the Congo',
    dialCode: '+243',
    flag: '🇨🇩',
  },
  { iso: 'DK', name: 'Denmark', dialCode: '+45', flag: '🇩🇰' },
  { iso: 'DJ', name: 'Djibouti', dialCode: '+253', flag: '🇩🇯' },
  { iso: 'DM', name: 'Dominica', dialCode: '+1767', flag: '🇩🇲' },
  { iso: 'DO', name: 'Dominican Republic', dialCode: '+1809', flag: '🇩🇴' },
  { iso: 'TL', name: 'East Timor', dialCode: '+670', flag: '🇹🇱' },
  { iso: 'EC', name: 'Ecuador', dialCode: '+593', flag: '🇪🇨' },
  { iso: 'EG', name: 'Egypt', dialCode: '+20', flag: '🇪🇬' },
  { iso: 'SV', name: 'El Salvador', dialCode: '+503', flag: '🇸🇻' },
  { iso: 'GQ', name: 'Equatorial Guinea', dialCode: '+240', flag: '🇬🇶' },
  { iso: 'ER', name: 'Eritrea', dialCode: '+291', flag: '🇪🇷' },
  { iso: 'EE', name: 'Estonia', dialCode: '+372', flag: '🇪🇪' },
  { iso: 'ET', name: 'Ethiopia', dialCode: '+251', flag: '🇪🇹' },
  { iso: 'FK', name: 'Falkland Islands', dialCode: '+500', flag: '🇫🇰' },
  { iso: 'FO', name: 'Faroe Islands', dialCode: '+298', flag: '🇫🇴' },
  { iso: 'FJ', name: 'Fiji', dialCode: '+679', flag: '🇫🇯' },
  { iso: 'FI', name: 'Finland', dialCode: '+358', flag: '🇫🇮' },
  { iso: 'FR', name: 'France', dialCode: '+33', flag: '🇫🇷' },
  { iso: 'PF', name: 'French Polynesia', dialCode: '+689', flag: '🇵🇫' },
  { iso: 'GA', name: 'Gabon', dialCode: '+241', flag: '🇬🇦' },
  { iso: 'GM', name: 'Gambia', dialCode: '+220', flag: '🇬🇲' },
  { iso: 'GE', name: 'Georgia', dialCode: '+995', flag: '🇬🇪' },
  { iso: 'DE', name: 'Germany', dialCode: '+49', flag: '🇩🇪' },
  { iso: 'GH', name: 'Ghana', dialCode: '+233', flag: '🇬🇭' },
  { iso: 'GI', name: 'Gibraltar', dialCode: '+350', flag: '🇬🇮' },
  { iso: 'GR', name: 'Greece', dialCode: '+30', flag: '🇬🇷' },
  { iso: 'GL', name: 'Greenland', dialCode: '+299', flag: '🇬🇱' },
  { iso: 'GD', name: 'Grenada', dialCode: '+1473', flag: '🇬🇩' },
  { iso: 'GU', name: 'Guam', dialCode: '+1671', flag: '🇬🇺' },
  { iso: 'GT', name: 'Guatemala', dialCode: '+502', flag: '🇬🇹' },
  { iso: 'GG', name: 'Guernsey', dialCode: '+44', flag: '🇬🇬' },
  { iso: 'GN', name: 'Guinea', dialCode: '+224', flag: '🇬🇳' },
  { iso: 'GW', name: 'Guinea-Bissau', dialCode: '+245', flag: '🇬🇼' },
  { iso: 'GY', name: 'Guyana', dialCode: '+592', flag: '🇬🇾' },
  { iso: 'HT', name: 'Haiti', dialCode: '+509', flag: '🇭🇹' },
  { iso: 'HN', name: 'Honduras', dialCode: '+504', flag: '🇭🇳' },
  { iso: 'HK', name: 'Hong Kong', dialCode: '+852', flag: '🇭🇰' },
  { iso: 'HU', name: 'Hungary', dialCode: '+36', flag: '🇭🇺' },
  { iso: 'IS', name: 'Iceland', dialCode: '+354', flag: '🇮🇸' },
  { iso: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳' },
  { iso: 'ID', name: 'Indonesia', dialCode: '+62', flag: '🇮🇩' },
  { iso: 'IR', name: 'Iran', dialCode: '+98', flag: '🇮🇷' },
  { iso: 'IQ', name: 'Iraq', dialCode: '+964', flag: '🇮🇶' },
  { iso: 'IE', name: 'Ireland', dialCode: '+353', flag: '🇮🇪' },
  { iso: 'IM', name: 'Isle of Man', dialCode: '+44', flag: '🇮🇲' },
  { iso: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { iso: 'IT', name: 'Italy', dialCode: '+39', flag: '🇮🇹' },
  { iso: 'CI', name: 'Ivory Coast', dialCode: '+225', flag: '🇨🇮' },
  { iso: 'JM', name: 'Jamaica', dialCode: '+1876', flag: '🇯🇲' },
  { iso: 'JP', name: 'Japan', dialCode: '+81', flag: '🇯🇵' },
  { iso: 'JE', name: 'Jersey', dialCode: '+44', flag: '🇯🇪' },
  { iso: 'JO', name: 'Jordan', dialCode: '+962', flag: '🇯🇴' },
  { iso: 'KZ', name: 'Kazakhstan', dialCode: '+7', flag: '🇰🇿' },
  { iso: 'KE', name: 'Kenya', dialCode: '+254', flag: '🇰🇪' },
  { iso: 'KI', name: 'Kiribati', dialCode: '+686', flag: '🇰🇮' },
  { iso: 'XK', name: 'Kosovo', dialCode: '+383', flag: '🇽🇰' },
  { iso: 'KW', name: 'Kuwait', dialCode: '+965', flag: '🇰🇼' },
  { iso: 'KG', name: 'Kyrgyzstan', dialCode: '+996', flag: '🇰🇬' },
  { iso: 'LA', name: 'Laos', dialCode: '+856', flag: '🇱🇦' },
  { iso: 'LV', name: 'Latvia', dialCode: '+371', flag: '🇱🇻' },
  { iso: 'LB', name: 'Lebanon', dialCode: '+961', flag: '🇱🇧' },
  { iso: 'LS', name: 'Lesotho', dialCode: '+266', flag: '🇱🇸' },
  { iso: 'LR', name: 'Liberia', dialCode: '+231', flag: '🇱🇷' },
  { iso: 'LY', name: 'Libya', dialCode: '+218', flag: '🇱🇾' },
  { iso: 'LI', name: 'Liechtenstein', dialCode: '+423', flag: '🇱🇮' },
  { iso: 'LT', name: 'Lithuania', dialCode: '+370', flag: '🇱🇹' },
  { iso: 'LU', name: 'Luxembourg', dialCode: '+352', flag: '🇱🇺' },
  { iso: 'MO', name: 'Macau', dialCode: '+853', flag: '🇲🇴' },
  { iso: 'MK', name: 'Macedonia', dialCode: '+389', flag: '🇲🇰' },
  { iso: 'MG', name: 'Madagascar', dialCode: '+261', flag: '🇲🇬' },
  { iso: 'MW', name: 'Malawi', dialCode: '+265', flag: '🇲🇼' },
  { iso: 'MY', name: 'Malaysia', dialCode: '+60', flag: '🇲🇾' },
  { iso: 'MV', name: 'Maldives', dialCode: '+960', flag: '🇲🇻' },
  { iso: 'ML', name: 'Mali', dialCode: '+223', flag: '🇲🇱' },
  { iso: 'MT', name: 'Malta', dialCode: '+356', flag: '🇲🇹' },
  { iso: 'MH', name: 'Marshall Islands', dialCode: '+692', flag: '🇲🇭' },
  { iso: 'MR', name: 'Mauritania', dialCode: '+222', flag: '🇲🇷' },
  { iso: 'MU', name: 'Mauritius', dialCode: '+230', flag: '🇲🇺' },
  { iso: 'YT', name: 'Mayotte', dialCode: '+262', flag: '🇾🇹' },
  { iso: 'MX', name: 'Mexico', dialCode: '+52', flag: '🇲🇽' },
  { iso: 'FM', name: 'Micronesia', dialCode: '+691', flag: '🇫🇲' },
  { iso: 'MD', name: 'Moldova', dialCode: '+373', flag: '🇲🇩' },
  { iso: 'MC', name: 'Monaco', dialCode: '+377', flag: '🇲🇨' },
  { iso: 'MN', name: 'Mongolia', dialCode: '+976', flag: '🇲🇳' },
  { iso: 'ME', name: 'Montenegro', dialCode: '+382', flag: '🇲🇪' },
  { iso: 'MS', name: 'Montserrat', dialCode: '+1664', flag: '🇲🇸' },
  { iso: 'MA', name: 'Morocco', dialCode: '+212', flag: '🇲🇦' },
  { iso: 'MZ', name: 'Mozambique', dialCode: '+258', flag: '🇲🇿' },
  { iso: 'MM', name: 'Myanmar', dialCode: '+95', flag: '🇲🇲' },
  { iso: 'NA', name: 'Namibia', dialCode: '+264', flag: '🇳🇦' },
  { iso: 'NR', name: 'Nauru', dialCode: '+674', flag: '🇳🇷' },
  { iso: 'NP', name: 'Nepal', dialCode: '+977', flag: '🇳🇵' },
  { iso: 'NL', name: 'Netherlands', dialCode: '+31', flag: '🇳🇱' },
  { iso: 'AN', name: 'Netherlands Antilles', dialCode: '+599', flag: '🇦🇳' },
  { iso: 'NC', name: 'New Caledonia', dialCode: '+687', flag: '🇳🇨' },
  { iso: 'NZ', name: 'New Zealand', dialCode: '+64', flag: '🇳🇿' },
  { iso: 'NI', name: 'Nicaragua', dialCode: '+505', flag: '🇳🇮' },
  { iso: 'NE', name: 'Niger', dialCode: '+227', flag: '🇳🇪' },
  { iso: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
  { iso: 'NU', name: 'Niue', dialCode: '+683', flag: '🇳🇺' },
  { iso: 'KP', name: 'North Korea', dialCode: '+850', flag: '🇰🇵' },
  {
    iso: 'MP',
    name: 'Northern Mariana Islands',
    dialCode: '+1670',
    flag: '🇲🇵',
  },
  { iso: 'NO', name: 'Norway', dialCode: '+47', flag: '🇳🇴' },
  { iso: 'OM', name: 'Oman', dialCode: '+968', flag: '🇴🇲' },
  { iso: 'PK', name: 'Pakistan', dialCode: '+92', flag: '🇵🇰' },
  { iso: 'PW', name: 'Palau', dialCode: '+680', flag: '🇵🇼' },
  { iso: 'PS', name: 'Palestine', dialCode: '+970', flag: '🇵🇸' },
  { iso: 'PA', name: 'Panama', dialCode: '+507', flag: '🇵🇦' },
  { iso: 'PG', name: 'Papua New Guinea', dialCode: '+675', flag: '🇵🇬' },
  { iso: 'PY', name: 'Paraguay', dialCode: '+595', flag: '🇵🇾' },
  { iso: 'PE', name: 'Peru', dialCode: '+51', flag: '🇵🇪' },
  { iso: 'PH', name: 'Philippines', dialCode: '+63', flag: '🇵🇭' },
  { iso: 'PN', name: 'Pitcairn', dialCode: '+870', flag: '🇵🇳' },
  { iso: 'PL', name: 'Poland', dialCode: '+48', flag: '🇵🇱' },
  { iso: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { iso: 'PR', name: 'Puerto Rico', dialCode: '+1', flag: '🇵🇷' },
  { iso: 'QA', name: 'Qatar', dialCode: '+974', flag: '🇶🇦' },
  { iso: 'CG', name: 'Republic of the Congo', dialCode: '+242', flag: '🇨🇬' },
  { iso: 'RE', name: 'Reunion', dialCode: '+262', flag: '🇷🇪' },
  { iso: 'RO', name: 'Romania', dialCode: '+40', flag: '🇷🇴' },
  { iso: 'RU', name: 'Russia', dialCode: '+7', flag: '🇷🇺' },
  { iso: 'RW', name: 'Rwanda', dialCode: '+250', flag: '🇷🇼' },
  { iso: 'BL', name: 'Saint Barthelemy', dialCode: '+590', flag: '🇧🇱' },
  { iso: 'SH', name: 'Saint Helena', dialCode: '+290', flag: '🇸🇭' },
  { iso: 'KN', name: 'Saint Kitts and Nevis', dialCode: '+1869', flag: '🇰🇳' },
  { iso: 'LC', name: 'Saint Lucia', dialCode: '+1758', flag: '🇱🇨' },
  { iso: 'MF', name: 'Saint Martin', dialCode: '+590', flag: '🇲🇫' },
  {
    iso: 'PM',
    name: 'Saint Pierre and Miquelon',
    dialCode: '+508',
    flag: '🇵🇲',
  },
  {
    iso: 'VC',
    name: 'Saint Vincent and the Grenadines',
    dialCode: '+1784',
    flag: '🇻🇨',
  },
  { iso: 'WS', name: 'Samoa', dialCode: '+685', flag: '🇼🇸' },
  { iso: 'SM', name: 'San Marino', dialCode: '+378', flag: '🇸🇲' },
  { iso: 'ST', name: 'Sao Tome and Principe', dialCode: '+239', flag: '🇸🇹' },
  { iso: 'SA', name: 'Saudi Arabia', dialCode: '+966', flag: '🇸🇦' },
  { iso: 'SN', name: 'Senegal', dialCode: '+221', flag: '🇸🇳' },
  { iso: 'RS', name: 'Serbia', dialCode: '+381', flag: '🇷🇸' },
  { iso: 'SC', name: 'Seychelles', dialCode: '+248', flag: '🇸🇨' },
  { iso: 'SL', name: 'Sierra Leone', dialCode: '+232', flag: '🇸🇱' },
  { iso: 'SG', name: 'Singapore', dialCode: '+65', flag: '🇸🇬' },
  { iso: 'SX', name: 'Sint Maarten', dialCode: '+1721', flag: '🇸🇽' },
  { iso: 'SK', name: 'Slovakia', dialCode: '+421', flag: '🇸🇰' },
  { iso: 'SI', name: 'Slovenia', dialCode: '+386', flag: '🇸🇮' },
  { iso: 'SB', name: 'Solomon Islands', dialCode: '+677', flag: '🇸🇧' },
  { iso: 'SO', name: 'Somalia', dialCode: '+252', flag: '🇸🇴' },
  { iso: 'ZA', name: 'South Africa', dialCode: '+27', flag: '🇿🇦' },
  { iso: 'KR', name: 'South Korea', dialCode: '+82', flag: '🇰🇷' },
  { iso: 'SS', name: 'South Sudan', dialCode: '+211', flag: '🇸🇸' },
  { iso: 'ES', name: 'Spain', dialCode: '+34', flag: '🇪🇸' },
  { iso: 'LK', name: 'Sri Lanka', dialCode: '+94', flag: '🇱🇰' },
  { iso: 'SD', name: 'Sudan', dialCode: '+249', flag: '🇸🇩' },
  { iso: 'SR', name: 'Suriname', dialCode: '+597', flag: '🇸🇷' },
  { iso: 'SJ', name: 'Svalbard and Jan Mayen', dialCode: '+47', flag: '🇸🇯' },
  { iso: 'SZ', name: 'Swaziland', dialCode: '+268', flag: '🇸🇿' },
  { iso: 'SE', name: 'Sweden', dialCode: '+46', flag: '🇸🇪' },
  { iso: 'CH', name: 'Switzerland', dialCode: '+41', flag: '🇨🇭' },
  { iso: 'SY', name: 'Syria', dialCode: '+963', flag: '🇸🇾' },
  { iso: 'TW', name: 'Taiwan', dialCode: '+886', flag: '🇹🇼' },
  { iso: 'TJ', name: 'Tajikistan', dialCode: '+992', flag: '🇹🇯' },
  { iso: 'TZ', name: 'Tanzania', dialCode: '+255', flag: '🇹🇿' },
  { iso: 'TH', name: 'Thailand', dialCode: '+66', flag: '🇹🇭' },
  { iso: 'TG', name: 'Togo', dialCode: '+228', flag: '🇹🇬' },
  { iso: 'TK', name: 'Tokelau', dialCode: '+690', flag: '🇹🇰' },
  { iso: 'TO', name: 'Tonga', dialCode: '+676', flag: '🇹🇴' },
  { iso: 'TT', name: 'Trinidad and Tobago', dialCode: '+1868', flag: '🇹🇹' },
  { iso: 'TN', name: 'Tunisia', dialCode: '+216', flag: '🇹🇳' },
  { iso: 'TR', name: 'Turkey', dialCode: '+90', flag: '🇹🇷' },
  { iso: 'TM', name: 'Turkmenistan', dialCode: '+993', flag: '🇹🇲' },
  {
    iso: 'TC',
    name: 'Turks and Caicos Islands',
    dialCode: '+1649',
    flag: '🇹🇨',
  },
  { iso: 'TV', name: 'Tuvalu', dialCode: '+688', flag: '🇹🇻' },
  { iso: 'VI', name: 'U.S. Virgin Islands', dialCode: '+1340', flag: '🇻🇮' },
  { iso: 'UG', name: 'Uganda', dialCode: '+256', flag: '🇺🇬' },
  { iso: 'UA', name: 'Ukraine', dialCode: '+380', flag: '🇺🇦' },
  { iso: 'AE', name: 'United Arab Emirates', dialCode: '+971', flag: '🇦🇪' },
  { iso: 'GB', name: 'United Kingdom', dialCode: '+44', flag: '🇬🇧' },
  { iso: 'US', name: 'United States', dialCode: '+1', flag: '🇺🇸' },
  { iso: 'UY', name: 'Uruguay', dialCode: '+598', flag: '🇺🇾' },
  { iso: 'UZ', name: 'Uzbekistan', dialCode: '+998', flag: '🇺🇿' },
  { iso: 'VU', name: 'Vanuatu', dialCode: '+678', flag: '🇻🇺' },
  { iso: 'VA', name: 'Vatican', dialCode: '+379', flag: '🇻🇦' },
  { iso: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪' },
  { iso: 'VN', name: 'Vietnam', dialCode: '+84', flag: '🇻🇳' },
  { iso: 'WF', name: 'Wallis and Futuna', dialCode: '+681', flag: '🇼🇫' },
  { iso: 'EH', name: 'Western Sahara', dialCode: '+212', flag: '🇪🇭' },
  { iso: 'YE', name: 'Yemen', dialCode: '+967', flag: '🇾🇪' },
  { iso: 'ZM', name: 'Zambia', dialCode: '+260', flag: '🇿🇲' },
  { iso: 'ZW', name: 'Zimbabwe', dialCode: '+263', flag: '🇿🇼' },
]
